export default {
  "hierarchy": {
    "pagination": [
      "combobox-pagination"
    ]
  },
  "props": {
    "default": {
      "selectIcon": "lv lv-chevron-down"
    },
    "pagination": {
      "selectIcon": "lv lv-chevron-down"
    }
  }
}